export default __webpack_public_path__ + "static/media/oola_black_logo.b1173292.svg";